var ViewHelper = {
	formatDate: date => date.split('-').reverse().join('.'),
	formatDecimal: val => isNaN(val) ? undefined : val.toFixed(2).toString().replace('.', ',')
};

module.exports = ViewHelper;



// WEBPACK FOOTER //
// ./src/assets/js/ViewHelper.js